import React from 'react';
import NavBarAuth from '../NavBarAuth';
import Footer from '../Footer';
import { Outlet } from 'react-router-dom';

/**
 * Layout component for authenticated pages
 * Includes the authenticated navigation bar and common elements
 */
const AuthenticatedLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBarAuth />
      <main className="flex-grow pt-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default AuthenticatedLayout;
